module.exports = __webpack_public_path__ + "img/reset_program_main.79a7ded6.png";